import React from "react";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";

import Model1Form from "../Model1Form";
import {useModel1Query, useUpdateModel1} from "../query";

import MDBox from "materialDashboard/components/MDBox";


const Model1Edit = () => {
    const {t} = useTranslation(['models1', 'validation', 'enums']);
    const navigate = useNavigate();
    const {model1Id} = useParams();

    // We have to use cacheTime: 0 to force to fetch fresh data. Otherwise, when
    // there is in the cache an older version of the model1 that version is the
    // passed to the form first and is initialized as initialValue in formik,
    // the fresh version that comes later will be ignored by formik.
    const model1Query = useModel1Query(model1Id, {cacheTime: 0});
    const updateModel1 = useUpdateModel1(model1Id);

    const handleSubmit = async (data) => {
        await updateModel1.mutateAsync(data);
        await navigate('/models1');
    }

    return <MDBox sx={{mx: 2}}>
        {
            model1Query.isLoading ? "Loading" : <Model1Form title={t('model1Edit.title')}
                                                            initialData={model1Query.data}
                                                            onSubmit={handleSubmit}/>
        }
    </MDBox>
}

export default Model1Edit;